import { render, staticRenderFns } from "./RoleUserList.vue?vue&type=template&id=4b5cc8a8&scoped=true"
import script from "./RoleUserList.vue?vue&type=script&lang=js"
export * from "./RoleUserList.vue?vue&type=script&lang=js"
import style0 from "./RoleUserList.vue?vue&type=style&index=0&id=4b5cc8a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5cc8a8",
  null
  
)

export default component.exports